import React, {useState} from 'react'
import {
    Button,
    Icon,
    IconButton,
    InputAdornment,
} from '@material-ui/core'
import {useTheme} from '@material-ui/core/styles'
import ReactLoading from 'react-loading'
import {Checkbox, TextField} from 'src/common/razzle-platform-components/form-fields'


export const DefaultTextField = (props) => (
    <TextField
        type={props.type}
        name={props.name}
        label={props.label}
        fullWidth={true}
        disabled={!!props.inProgress}
        required={!!props.required}
        validate={props.validate}
    />
)


export const DefaultPasswordField = (props) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            name={props.name}
            label={props.label}
            fullWidth={true}
            disabled={!!props.inProgress}
            autoComplete="current-password"
            required={!!props.required}
            validate={props.validate}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="Toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <Icon >visibility_off</Icon> : <Icon >visibility</Icon>}
                    </IconButton>
                </InputAdornment>
            }
        />
    )
}

export const DefaultCheckBoxField = (props) => (
    <Checkbox
        name={props.name}
        label={props.label}
        disabled={!!props.inProgress}
        required={!!props.required}
        validate={props.validate}
    />
)


export const DefaultSubmitButton = (props) => {
    const theme = useTheme()
    return (
        <Button
            type="submit"
            disableElevation
            variant="contained"
            color="primary"
            disabled={!!props.inProgress}
            fullWidth
        >
            { !!props.inProgress ?
                <ReactLoading type={'spokes'} color={theme.palette.primary.main} height={20} width={19}  />
            :
                <>{props.label}</>
            }

        </Button>
    )
}

export const DefaultButton = (props) => (
    <Button
        disableElevation
        variant="contained"
        color="primary"
        fullWidth
        onClick={props.onClick}
    >
        {props.children}
    </Button>
)
